import React, { useState, useEffect } from "react";

import styles from "./MeetingFollowUp.module.css";

const noOp = () => {};

const MeetingFollowUp = ({
  followUpStatus = false,
  onFollowUpChanged = noOp,
  className,
}) => {
  const [followUpRequested, setFollowUpRequested] = useState(followUpStatus);
  const onChange = (e) => {
    // the !! is a double negation;
    // the + simply casts the "0" or "1" string values to integers
    setFollowUpRequested(!!+e.target.value);
    onFollowUpChanged(!!+e.target.value);
  };

  // Re-render if the followUpStatus prop is updated from outside
  useEffect(() => setFollowUpRequested(followUpStatus), [followUpStatus]);

  return (
    <div className={`${styles.meetingFollowUp} ${className}`}>
      <div className={styles.label}>Set Follow-up Meeting</div>

      <div className="radio-btn-area">

        <div className="radio-item">
            <input type="radio" id="ritema" name="followUpRequested" value="1" onChange={onChange} checked={followUpRequested === true}/>
            <label for="ritema">Yes</label>
        </div>
        <div class="radio-item">
            <input type="radio" id="ritemb" name="followUpRequested" value="0" onChange={onChange} checked={followUpRequested === false}/>
            <label for="ritemb">No</label>
        </div>


      </div>
    </div>
  );
};

export default MeetingFollowUp;
